module.exports = __webpack_public_path__ + "static/media/fast-forward.ebc57627.svg";